import React from 'react';
import { SearchResult } from '../types';
import { ClubTile, EventTile } from './TileType';

export interface SearchTileProps {
    item: SearchResult;
}

export const SearchTile: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<SearchTileProps>>> = ({ item }) => {
    switch (item.type.toLowerCase() as Lowercase<SearchResult['type']>) {
        case 'insertion':
            return <ClubTile item={item} />;

        case 'event':
            return <EventTile item={item} />;

        default:
            return <></>;
    }
};
